import {
  maintenanceSlaType,
  maintenanceSlaTypeFullName,
} from "../types/index.const";

const maintenanceSLAOptions = maintenanceSlaType.map((el, index) => ({
  label: maintenanceSlaTypeFullName[index],
  value: el,
}));

export default maintenanceSLAOptions;
